import { render, staticRenderFns } from "./CardRed.vue?vue&type=template&id=1f9ea328&scoped=true"
import script from "./CardRed.vue?vue&type=script&lang=js"
export * from "./CardRed.vue?vue&type=script&lang=js"
import style0 from "./CardRed.vue?vue&type=style&index=0&id=1f9ea328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9ea328",
  null
  
)

export default component.exports